import { useState } from "react";
import { hotRankings } from "@/mocks/content";

const trendMap = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-500" },
  down: { icon: "ri-arrow-down-line", cls: "text-accent-600" },
  new: { icon: "ri-sparkling-fill", cls: "text-secondary-500" },
  flat: { icon: "ri-subtract-line", cls: "text-foreground-300" },
};

const heatColor = (rank: number) =>
  rank <= 3 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-600";

export default function HotRank() {
  const [active, setActive] = useState<string>("all");
  const tags = ["all", ...Array.from(new Set(hotRankings.map((r) => r.tag)))];
  const list = active === "all" ? hotRankings : hotRankings.filter((r) => r.tag === active);

  return (
    <section id="rank" className="scroll-mt-20 bg-background-100 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-600">
              <i className="ri-fire-line"></i> Trending Now
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日热点瓜料榜</h2>
            <p className="mt-2 text-sm text-foreground-600">实时热度排序，帮你快速锁定此刻最值得关注的瓜。</p>
          </div>
          <div className="flex flex-wrap gap-2 rounded-full bg-background-50 p-1">
            {tags.map((t) => (
              <button
                key={t}
                onClick={() => setActive(t)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${
                  active === t
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {t === "all" ? "全部" : t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {list.map((item) => {
            const t = trendMap[item.trend];
            return (
              <a
                key={item.rank}
                href="#featured"
                className="group flex cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition hover:-translate-y-0.5 hover:border-primary-200"
              >
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-base font-bold ${heatColor(item.rank)}`}>
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate text-base font-medium text-foreground-950 group-hover:text-primary-700">
                      {item.title}
                    </h3>
                  </div>
                  <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="whitespace-nowrap rounded-full bg-accent-50 px-2 py-0.5 text-accent-700">{item.tag}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-fire-line text-secondary-500"></i>
                      {item.heat}万热度
                    </span>
                  </div>
                </div>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 ${t.cls}`}>
                  <i className={t.icon}></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}